module.exports = __webpack_public_path__ + "static/media/location-circle.fe6d2053.svg";